import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20250902-solilauf",
        datum: "02.09.2025",
        kategorie: KategorieEnum.COMMUNITY,
        type: InsightTypeEnum.INFO,
        title: "Team HiOrg-Server beim Solilauf am 06.+07.09.2025",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE, LizenzEnum.FREE],
        content: [
            "🏃‍♀️‍➡️ Seit vielen Jahren sind wir beim örtlichen Solilauf dabei: So wie der HiOrg-Server rund um die Uhr" +
            " läuft, geben wir beim 24h-Lauf alles für den guten Zweck. Gemeinsam mit unseren Familien und Freunden" +
            " laufen wir als Team und unterstützen damit Bedürftige. Jede Runde zählt und mit eurer Spende könnt ihr" +
            " direkt helfen. 🏃‍➡️🏃‍♂️‍➡️",
            "👉 Am Wochenende ist es wieder soweit. Schaut in unseren Livestream, fiebert mit uns, und wenn ihr" +
            " möchtet: Unterstützt jede Runde mit einem kleinen Beitrag. Vielen Dank 🫶",
        ],
        aktions: [
            {
                type: AktionTypeEnum.LINK,
                text: "Jetzt unterstützen + Livestream",
                url: "https://solilauf.hiorg-server.de/",
            },
        ],
    },
];

export {
    insights,
};
